import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { PricingProfileAdminUserRole } from 'pricing/enums';
import { IPricingProfileAdminUser } from 'pricing/types';

import { ActionsCell } from './cells';

interface IColumnDefParams {
  isEditable?: boolean;
}

export const getColumnDef = ({ isEditable = true }: IColumnDefParams = {}): ColDef[] => [
  {
    colId: 'actions',
    width: 60,
    maxWidth: 60,
    sortable: false,
    resizable: false,
    cellRenderer: ActionsCell,
    cellRendererParams: {
      isEditable,
    },
    suppressColumnsToolPanel: true,
    pinned: 'left',
    lockPinned: true,
  },
  {
    colId: 'corporateUser',
    field: 'corporateUser.name',
    headerName: t('headerUser'),
    filter: 'agTextColumnFilter',
    flex: 2,
    minWidth: 200,
  },
  {
    colId: 'role',
    field: 'isOwner',
    headerName: t('headerRole'),
    valueGetter: ({ data }: { data: IPricingProfileAdminUser }) => {
      return data.isOwner ? t('labelOwner') : t('labelUser');
    },
    filter: 'agSetColumnFilter',
    filterParams: {
      values: [PricingProfileAdminUserRole.OWNER, PricingProfileAdminUserRole.USER],
      valueFormatter: ({ value }) => {
        return value === PricingProfileAdminUserRole.OWNER ? t('labelOwner') : t('labelUser');
      },
    },
    sortable: false,
    flex: 1,
    minWidth: 100,
  },
  {
    colId: 'location',
    field: 'corporateUser.address.name',
    headerName: t('headerLocation'),
    sortable: false,
    flex: 2,
    minWidth: 150,
  },
];
